import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import api from "../../globals/axios";
import { Box, Container, Card, Avatar, Divider } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CustomAppBar from "../../components/AppBar";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const DetailedQuestion = ({ context }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [question, setQuestion] = useState(null);
  const [answer, setAnswer] = useState("");
  const [farmerDetails, setFarmerDetails] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const endpoint =
      context === "answered"
        ? `/advisory/answers/answered_by_advisor/?id=${id}`
        : `/advisory/unanswered-questions/?id=${id}`;
    api
      .get(endpoint)
      .then((response) => {
        if (context === "answered") {
          setAnswer(response.data.translated_answer);
          setQuestion(response.data.question);
          setFarmerDetails(response.data.question.asked_by);
        } else {
          setQuestion(response.data);
          setFarmerDetails(response.data.asked_by);
        }
      })
      .catch((error) => {
        console.error("There was an error fetching the question!", error);
      });
  }, [id, context]);

  const handleSubmit = () => {
    setIsSubmitting(true);
    api
      .post(`/advisory/answers/`, { answer: answer, question_id: id }) // Change 'answer_text' to 'answer'
      .then((response) => {
        console.log("Answer submitted successfully", response);
        navigate("/");
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error("There was an error submitting the answer!", error);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <CustomAppBar />
      <Container
        maxWidth="xs"
        sx={{
          height: "84vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between", // Ensures space between top and bottom
          overflow: "scroll",
        }}
      >
        <Box sx={{ width: "100%", marginTop: "20px", height: "100%" }}>
          {farmerDetails && (
            <Card
              sx={{
                display: "flex",
                alignItems: "center",
                padding: "15px 10px",
                borderRadius: "4px",
                boxShadow: "1px 2px 4px 0px #86828240",
              }}
            >
              <Avatar
                src="path/to/your/image.jpg"
                sx={{ width: 80, height: 80, marginRight: "10px" }}
              />
              <Box sx={{ padding: "10px 0" }}>
                <Typography variant="body1">
                  {t("Farmer Name :")} {farmerDetails.full_name}
                </Typography>
                <Typography variant="body1">
                  {t("Mobile Number :")} {farmerDetails.phone_number}
                </Typography>
              </Box>
            </Card>
          )}
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end", // Align content to the bottom
            height: "100%",
          }}
        >
          <Box sx={{ width: "100%" }}>
            {question ? (
              <Box
                sx={{
                  padding: "0px 0",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end", // Align content to the bottom
                }}
              >
                <Box
                  sx={{
                    width: "fit-content",
                    maxWidth: "60%",
                    backgroundColor: "#ABDBCF",
                    padding: "20px",
                    borderRadius: "10px 10px 10px 0",
                    marginBottom: "20px",
                  }}
                >
                  <Typography variant="body1">{question.text}</Typography>
                  <Divider sx={{ margin: "5px 0" }} />
                  <Typography variant="body1">
                    {question.text !== question.text_en &&
                      ` ${question.text_en}`}
                  </Typography>
                </Box>

                {context === "answered" ? (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Box
                      sx={{
                        width: "fit-content",
                        maxWidth: "60%",
                        backgroundColor: "#76CD76",
                        padding: "20px",
                        borderRadius: "10px 10px 0 10px",
                      }}
                    >
                      <Typography variant="body1">{answer.text_en}</Typography>
                      <Divider sx={{ margin: "5px 0" }} />
                      <Typography variant="body1">{answer.text}</Typography>
                    </Box>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      marginTop: "20px",
                      width: "100%",
                      display: "flex",
                      alignItems: "stretch", // Ensure child elements stretch to full height
                      justifyContent: "space-between",
                    }}
                  >
                    <TextField
                      label="Reply"
                      multiline
                      rows={1}
                      value={answer}
                      onChange={(e) => setAnswer(e.target.value)}
                      variant="outlined"
                      sx={{ width: "78%", height: "auto" }}
                    />
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleSubmit}
                      sx={{
                        height: "inherit",
                        boxShadow: "none",
                        border: "1px solid #A5A5A5",
                      }}
                      disabled={isSubmitting}
                    >
                      <KeyboardArrowRightIcon
                        fontSize="large"
                        sx={{ color: "white" }}
                      />
                    </Button>
                  </Box>
                )}
              </Box>
            ) : (
              <p>{t("Loading question...")}</p>
            )}
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default DetailedQuestion;
